export const RafflePaymentTypes = {
  CreditCard: "CreditCard",
  Cash: "Cash",
  PayPal: "PayPal",
};
